import { erroDeDatas, type HoraDoDia } from './datas';

interface Props {
  dataIda: string;
  horarioIda: string;
  dataVolta: string;
  horarioVolta: string;
  somenteIda: boolean;
  onChange: (campo: 'dataIda' | 'horarioIda' | 'dataVolta' | 'horarioVolta', valor: string) => void;
}

function paraHora(hhmm: string): HoraDoDia | null {
  const [h, m] = hhmm.split(':').map(Number);
  return Number.isFinite(h) && Number.isFinite(m) ? { hour: h, minute: m } : null;
}

function Campo({ rotulo, tipo, valor, onChange }: { rotulo: string; tipo: string; valor: string; onChange: (v: string) => void }) {
  return (
    <label className="co-campo">
      <span className="co-campo-rotulo">{rotulo}</span>
      <input className="co-entrada" type={tipo} value={valor} onChange={e => onChange(e.target.value)} />
    </label>
  );
}

/**
 * Passo 4 — handoff §2: grid 2×2 (SAÍDA/HORA, RETORNO/HORA). Antecedência
 * mínima de 6h e vão ida×volta validados por datas.ts.
 */
export function PassoDatas({ dataIda, horarioIda, dataVolta, horarioVolta, somenteIda, onChange }: Props) {
  const horaIda = paraHora(horarioIda);
  const horaVolta = paraHora(horarioVolta);
  const erro = !somenteIda && dataIda && dataVolta && horaIda && horaVolta
    ? erroDeDatas({
        ida: new Date(dataIda), horaIda, volta: new Date(dataVolta), horaVolta, somenteIda,
      })
    : null;

  return (
    <div className="co-pilha">
      <div className="co-grade-2">
        <Campo rotulo="Saída" tipo="date" valor={dataIda} onChange={v => onChange('dataIda', v)} />
        <Campo rotulo="Hora da saída" tipo="time" valor={horarioIda} onChange={v => onChange('horarioIda', v)} />
      </div>
      {!somenteIda && (
        <div className="co-grade-2">
          <Campo rotulo="Retorno" tipo="date" valor={dataVolta} onChange={v => onChange('dataVolta', v)} />
          <Campo rotulo="Hora do retorno" tipo="time" valor={horarioVolta} onChange={v => onChange('horarioVolta', v)} />
        </div>
      )}
      <p className="co-apoio">Antecedência mínima de 6 horas.</p>
      {erro && <p className="co-apoio" role="alert">{erro}</p>}
    </div>
  );
}
